import React, { useEffect } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { IntlShape, injectIntl } from 'react-intl';
import { createStructuredSelector } from 'reselect';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import homePageBackgroundLawyer from 'images/homepage-background-lawyer.jpg';
import sanlamLogo from 'images/icon-sanlam.png';
import { COLORS } from 'constants/design';
import { translate } from 'containers/services/translate';
import messages from 'containers/PreOpenManagerHomePage/messages';
import PrimaryButton from 'components/Buttons/PrimaryButton';
import { Listings } from 'containers/AppContainer/typings';
import { makeSelectListings } from 'containers/AppContainer/selectors';
import { pushTo } from 'containers/services/routes-helper';
import { PAGES } from 'routes';
import { requestStatsClaims } from 'containers/HomePage/actions';
import { COUNT_CLAIMS_STATS } from 'containers/HomePage/constants';
import PendingClaims from 'containers/HomePage/PendingClaims';
import ValidatedClaims from 'containers/HomePage/ValidatedClaims';
import { makeSelectStatsClaims } from 'containers/HomePage/selectors';
export interface PreOpenManagerHomePageProps {
  intl: IntlShape;
  listings: Listings;
  requestStatsClaims: Function;
  statsClaims: any;
}
const Container = styled.div`
  &&.container {
    height: 400px;
    width: 100%;
    margin-top: 60px;
    background-color: ${COLORS.NAVY};
    background-image: url(${homePageBackgroundLawyer});
    background-repeat: no-repeat;
    background-size: cover;
    border-radius: 5px;
    background-position: 50% 50%;
    position: relative;
  }
  .bannerContainer {
    display: flex;
    width: 50%;
    height: 223px;
    position: relative;
    position: relative;
    bottom: -57px;
  }
  .custom-border {
    height: 100%;
    border: 10px solid #f2a900;
    margin-right: 5px;
  }
  .logo {
    padding: 0 10px;
  }
  .logo-image {
    width: 32px;
    height: 32px;
  }
  .identificationCTA {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 50%;
  }
  .title {
    font: Bold 31px Roboto;
    letter-spacing: 0;
    color: #ffffff;
  }
  .subTitle {
    font: Regular 16px Roboto;
    letter-spacing: 0;
    color: #d8d8d8;
  }
  #primary-button-style {
    width: 223px;
    height: 46px;
    color: #333e48;
    text-transform: none;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-around;
  }
`;
const Claims = styled.div`
  .claims {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
  }
  .pendingClaims {
    padding-top: 32px;
    width: 50%;
    margin-left: 15px;
  }
  .validatedClaims {
    padding-top: 32px;
    width: 50%;
    margin-right: 15px;
  }
`;
const PreOpenManagerHomePage: React.FC<PreOpenManagerHomePageProps> = (
  props,
): JSX.Element => {
  useEffect(() => {
    props.requestStatsClaims({ count: COUNT_CLAIMS_STATS });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <div>
      <Container className="container">
        <div className="bannerContainer">
          <div className="custom-border" />
          <div className="logo">
            <img src={sanlamLogo} alt="sanlam-logo" className="logo-image" />
          </div>
          <div className="identificationCTA">
            <span className="title">
              {translate({ ...messages.homePageTitle }, props)}
            </span>
            <span className="subTitle">
              {translate({ ...messages.homePageSubTitle }, props)}
            </span>
            <PrimaryButton
              onClick={pushTo(PAGES.IDENTIFICATION_PREOPEN_MANAGER)}
              lefticon={<ArrowForwardIcon />}
              title={translate({ ...messages.homePagePreOpeningButton }, props)}
            />
          </div>
        </div>
      </Container>
      <Claims>
        <div className="claims">
          <div className="validatedClaims">
            <ValidatedClaims
              claims={props.statsClaims.validated}
              isPreOpeningManager
            />
          </div>
          <div className="pendingClaims">
            <PendingClaims
              claims={props.statsClaims.pending}
              isPreOpeningManager
            />
          </div>
        </div>
      </Claims>
    </div>
  );
};

const mapDispatchToProps = {
  requestStatsClaims,
};

const mapStateToProps = createStructuredSelector({
  listings: makeSelectListings(),
  statsClaims: makeSelectStatsClaims(),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(PreOpenManagerHomePage));
